export const galleryItems = [
  {
    id: 1,
    image: "https://public.readdy.ai/ai/img_res/a90a14aa2dad4867888574640c1475d9.jpg",
    title: "Günlük Taze Balıklar",
    size: "large"
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=rustic%20turkish%20seafood%20restaurant%20interior%2C%20fishing%20nets%20hanging%20from%20ceiling%20wooden%20beams%2C%20warm%20amber%20lighting%2C%20white%20tablecloths%2C%20cozy%20dining%20atmosphere%2C%20mediterranean%20coastal%20decor&width=500&height=500&seq=gal2&orientation=squarish",
    title: "Restoranımız",
    size: "medium"
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=fisherman%20on%20traditional%20wooden%20boat%20pulling%20fishing%20nets%20at%20sunrise%2C%20aegean%20sea%20izmir%20turkey%2C%20golden%20morning%20light%20on%20calm%20water%2C%20authentic%20fishing%20lifestyle%2C%20silhouette&width=500&height=500&seq=gal3&orientation=squarish",
    title: "Sabah Avı",
    size: "medium"
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=happy%20turkish%20family%20enjoying%20seafood%20meal%20at%20restaurant%20table%2C%20smiling%20people%20eating%20grilled%20fish%20meze%20dishes%2C%20warm%20restaurant%20atmosphere%2C%20authentic%20dining%20experience%2C%20candlelight&width=800&height=400&seq=gal4&orientation=landscape",
    title: "Mutlu Misafirlerimiz",
    size: "wide"
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=chef%20in%20white%20apron%20grilling%20whole%20fish%20on%20charcoal%20grill%20in%20restaurant%20kitchen%2C%20flames%20and%20smoke%2C%20professional%20cooking%2C%20turkish%20seafood%20restaurant%20kitchen%2C%20action%20shot&width=500&height=400&seq=gal5&orientation=landscape",
    title: "Mutfağımızdan",
    size: "medium"
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=beautiful%20seafood%20meze%20spread%20on%20restaurant%20table%2C%20variety%20of%20turkish%20appetizers%20stuffed%20mussels%20calamari%20salads%20olives%20bread%2C%20overhead%20view%2C%20mediterranean%20feast%2C%20professional%20food%20photography&width=500&height=400&seq=gal6&orientation=landscape",
    title: "Meze Soframız",
    size: "medium"
  }
];
